/* DNS: hover a product card -> crossfade to the design only (image whose alt ends "design only" or "poster artwork") */
(function(){
  if(!window.matchMedia||!matchMedia('(hover:hover)').matches) return;
  var cache=Object.create(null);
  function designUrl(handle){
    if(cache[handle]) return cache[handle];
    cache[handle]=fetch('/products/'+handle+'.js').then(function(r){return r.ok?r.json():null}).then(function(p){
      if(!p||!p.images) return null; var u=null;
      (p.media||[]).forEach(function(m){ if(!u&&m.media_type==='image'&&/(design only|poster artwork)$/i.test(m.alt||'')) u=m.src; });
      return u;
    }).catch(function(){return null});
    return cache[handle];
  }
  function show(card){
    var box=card.querySelector('.dns-card__image'); if(!box||box.dataset.hov==='none') return;
    var h=(card.getAttribute('href')||'').split('/products/')[1]; if(!h) return; h=h.split('?')[0];
    designUrl(h).then(function(u){
      if(!u){ box.dataset.hov='none'; return; }
      var o=box.querySelector('.dns-card__hover');
      if(!o){ o=document.createElement('img'); o.className='dns-card__hover'; o.alt=''; o.decoding='async'; o.src=u+(u.indexOf('?')>-1?'&':'?')+'width=720'; box.appendChild(o); }
      if(card.matches(':hover')) requestAnimationFrame(function(){o.classList.add('on')});
    });
  }
  function hide(card){ var o=card.querySelector('.dns-card__hover'); if(o) o.classList.remove('on'); }
  document.addEventListener('mouseover',function(e){var c=e.target.closest&&e.target.closest('.dns-card'); if(c&&!c.contains(e.relatedTarget)) show(c)});
  document.addEventListener('mouseout',function(e){var c=e.target.closest&&e.target.closest('.dns-card'); if(c&&!c.contains(e.relatedTarget)) hide(c)});
})();
